import { useState, MouseEvent } from 'react';
import {
  ModalContainer,
  ModalContent,
  ButtonGroup,
  CancelButton,
  SaveButton,
  StyledH2,
  TextWrapper,
  CloseIconWrapper
} from './styles';
import CloseIcon from 'shared/icons/mediaBottomMenuIcons/CloseIcon';
import { useDispatch } from 'react-redux';
import { modalControllerActions } from 'core';

interface ConfirmPopUpProps {
  title: string;
  description?: string;
  onSave: () => void;
  onCancel: () => void;
  saveText?: string;
  cancelText?: string;
}

export const ConfirmPopUp = ({
  title,
  description,
  onSave,
  onCancel,
  saveText = 'Сохранить',
  cancelText = 'Отменить'
}: ConfirmPopUpProps) => {
  const [visible, setVisible] = useState(true);
  const dispatch = useDispatch();
  const handleSave = () => {
    setVisible(false);
    onSave();
  };
  const handleCancel = () => {
    setVisible(false);
    dispatch(modalControllerActions.setConfirmPopUpOpen(false));
    onCancel();
  };

  const closeBySpaceClick = (e: MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      handleCancel();
    }
  };

  if (!visible) return null;

  return (
    <ModalContainer onClick={closeBySpaceClick}>
      <ModalContent>
        <TextWrapper>
          <StyledH2>{title}</StyledH2>
          <CloseIconWrapper onClick={handleCancel}><CloseIcon width='24px' height='24px'></CloseIcon></CloseIconWrapper>
        </TextWrapper>
        <ButtonGroup>
          <CancelButton onClick={handleCancel}>{cancelText}</CancelButton>
          <SaveButton onClick={handleSave}>{saveText}</SaveButton>
        </ButtonGroup>
      </ModalContent>
    </ModalContainer>
  );
};import { useState, MouseEvent } from 'react';
import {
  ModalContainer,
  ModalContent,
  ButtonGroup,
  CancelButton,
  SaveButton,
  StyledH2,
  TextWrapper,
  CloseIconWrapper
} from './styles';
import CloseIcon from 'shared/icons/mediaBottomMenuIcons/CloseIcon';
import { useDispatch } from 'react-redux';
import { modalControllerActions } from 'core';

interface ConfirmPopUpProps {
  title: string;
  description?: string;
  onSave: () => void;
  onCancel: () => void;
  saveText?: string;
  cancelText?: string;
}

export const ConfirmPopUp = ({
  title,
  description,
  onSave,
  onCancel,
  saveText = 'Сохранить',
  cancelText = 'Отменить'
}: ConfirmPopUpProps) => {
  const [visible, setVisible] = useState(true);
  const dispatch = useDispatch();
  const handleSave = () => {
    setVisible(false);
    onSave();
  };
  const handleCancel = () => {
    setVisible(false);
    dispatch(modalControllerActions.setConfirmPopUpOpen(false));
    onCancel();
  };

  const closeBySpaceClick = (e: MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      handleCancel();
    }
  };

  if (!visible) return null;

  return (
    <ModalContainer onClick={closeBySpaceClick}>
      <ModalContent>
        <TextWrapper>
          <StyledH2>{title}</StyledH2>
          <CloseIconWrapper onClick={handleCancel}><CloseIcon width='24px' height='24px'></CloseIcon></CloseIconWrapper>
        </TextWrapper>
        <ButtonGroup>
          <CancelButton onClick={handleCancel}>{cancelText}</CancelButton>
          <SaveButton onClick={handleSave}>{saveText}</SaveButton>
        </ButtonGroup>
      </ModalContent>
    </ModalContainer>
  );
};